import * as React from 'react';
import classnames from 'classnames';
import { MediaQuery } from '@grandvisionhq/common';
import { ColumnedDropdown } from '@grandvisionhq/forms';
import { useIntl } from '@grandvisionhq/state';
import { powerToFloat, getEyeLabel, getAttributeLabel } from '../../../../../utils.js';
import { LabelWithTooltip } from '../LabelWithTooltip/LabelWithTooltip.js';
import { SelectElement } from '../SelectElement/SelectElement.js';
import { SelectWrapper } from '../SelectWrapper/SelectWrapper.js';

const PowerSelector = ({ attributes , isActive , hasError , className , id , activeFilters , foundProduct , handleAttributeChange , options , initialValue  })=>{
    const intl = useIntl();
    const isInvalid = hasError && !foundProduct && isActive;
    const isMobile = MediaQuery.useIsBelow(MediaQuery.BreakpointName.TABLET_LANDSCAPE);
    const positiveOptions = options.filter((power)=>powerToFloat(power) >= 0
    );
    const negativeOptions = options.filter((power)=>powerToFloat(power) <= 0
    );
    negativeOptions.reverse() // 🙈 mutation; reversed for the UI (eg render 0 - -5 instead of -5 - 0)
    ;
    const eyeLabel = getEyeLabel(intl, id);
    const attributeLabel = getAttributeLabel(intl, 'power');
    return !isMobile ? /*#__PURE__*/ React.createElement(SelectWrapper, {
        key: "power"
    }, /*#__PURE__*/ React.createElement(LabelWithTooltip, {
        type: "power",
        id: id
    }), /*#__PURE__*/ React.createElement(ColumnedDropdown, {
        className: classnames('power-selector__select', className),
        options: options,
        leftColumnOptions: negativeOptions,
        rightColumnOptions: positiveOptions,
        placeholder: initialValue,
        onChange: ({ value  })=>handleAttributeChange('power', value)
        ,
        disabled: !isActive,
        "aria-label": `${attributeLabel} ${eyeLabel}`,
        "aria-invalid": isInvalid,
        "data-t": "prescription-power"
    })) : /*#__PURE__*/ React.createElement(SelectElement, {
        attribute: "power",
        isActive: isActive,
        hasError: isInvalid,
        id: id,
        activeFilters: activeFilters,
        foundProduct: foundProduct,
        handleAttributeChange: handleAttributeChange,
        attributes: attributes
    });
};

export { PowerSelector };
//# sourceMappingURL=PowerSelector.js.map
